import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { watchForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    DispatchBeginSignIn,
    RedirectToChangeCustomer,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

type signInHandlerProps = Parameters<typeof DispatchBeginSignIn>[0];

function CustomBypassChangeCustomer(props: signInHandlerProps) {
    if (!props.authenticatedSession?.redirectToChangeCustomerPageOnSignIn) {
        watchForOtherTabSessionChange(); // This sign-in failed, but another tab might be successful later on.
    }
}

function SkipRedirectFromConfirmationPage(props: signInHandlerProps) {
    const confirmationPage = getPageLinkByPageType(props.getState(), "OrderConfirmationPage")?.url;
    if (
        props.parameter?.returnUrl &&
        props.parameter.returnUrl.toLowerCase().indexOf(confirmationPage!.toLowerCase()) > -1
    ) {
        window.location.href = getHomePageUrl(props.getState());
        return false;
    }
}

replaceInChain(chain, RedirectToChangeCustomer, CustomBypassChangeCustomer);

addToChainAfter(chain, CustomBypassChangeCustomer, SkipRedirectFromConfirmationPage);
